import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Auth Providers
import { KeycloakProvider } from './context/KeycloakContext';
import { AuthProvider } from './context/AuthContext';

// Components
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';

// Pages
import Dashboard from './pages/Dashboard';
import QueueActivities from './pages/QueueActivities';
import CodexDetail from './pages/CodexDetail';
import NotFound from './pages/NotFound';
import Queues from './pages/Queues';
import CodexTypes from './pages/CodexTypes';
import NewCodexType from './pages/NewCodexType';
import SystemSettings from './pages/SystemSettings';
import Registries from './pages/Registries';
import CodexList from './pages/CodexList';
import CodexProcessList from './pages/CodexProcessList';
import Documenti from './pages/Documenti';
import TestValidation from './pages/TestValidation';
import NewCodex from './pages/NewCodex';
import PromptSettings from './pages/PromptSettings';
import NewPrompt from './pages/NewPrompt';
import NewPromptFragment from './pages/NewPromptFragment';
import ProcessSettings from './pages/ProcessSettings';
import NewProcess from './pages/NewProcess';

// Import custom theme
import theme from './theme';
import env from './config/env';

function App() {
  const useKeycloakAuth = env.useKeycloakAuth;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <KeycloakProvider>
        <AuthProvider>
          <Router>
            <Routes>
              {/* Public route for login - only when not using Keycloak */}
              {!useKeycloakAuth && (
                <Route path="/login" element={<Login />} />
              )}

              {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/codex-list" element={<CodexList />} />
                <Route path="/documenti" element={<Documenti />} />
                <Route path="/codexes" element={<CodexList />} />
                <Route path="/new-codex" element={<NewCodex />} />
                <Route path="/codex-process-list" element={<CodexProcessList />} />
                <Route path="/queues/:queueId" element={<QueueActivities />} />

                {/* Nuove rotte per le pagine di configurazione */}
                <Route path="/queues" element={<Queues />} />
                <Route path="/codex-types" element={<CodexTypes />} />
                <Route path="/new-codex-type" element={<NewCodexType />} />
                <Route path="/codex-types/:id" element={<NewCodexType />} />
                <Route path="/system-settings" element={<SystemSettings />} />
                <Route path="/registries" element={<Registries />} />
                <Route path="/prompts" element={<PromptSettings />} />
                <Route path="/new-prompt" element={<NewPrompt />} />
                <Route path="/prompts/:id" element={<NewPrompt />} />
                <Route path="/new-prompt-fragment" element={<NewPromptFragment />} />
                <Route path="/prompt-fragments/:id" element={<NewPromptFragment />} />
                <Route path="/test-validation" element={<TestValidation />} />
                <Route path="/processes" element={<ProcessSettings />} />
                <Route path="/new-process" element={<NewProcess />} />
                <Route path="/processes/:id" element={<NewProcess />} />
                <Route path="/codex/:codexId" element={<CodexDetail />} />
              </Route>
            </Route>

              {/* Redirect root to dashboard */}
              <Route
                path="/"
                element={<Navigate to="/dashboard" replace />}
              />

              {/* 404 Not Found */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </AuthProvider>
      </KeycloakProvider>
    </ThemeProvider>
  );
}

export default App;
